import { render, staticRenderFns } from "./AppDropzone.vue?vue&type=template&id=b074c89a&"
import script from "./AppDropzone.vue?vue&type=script&lang=js&"
export * from "./AppDropzone.vue?vue&type=script&lang=js&"
import style0 from "./AppDropzone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports